import { ReactElement } from 'react'
import BasePage from '../layout'
import IBSCPage from './index'

export default (): ReactElement => (
  <BasePage>
    <IBSCPage />
  </BasePage>
)
